var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 31,
    viewBox: "0 0 169 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1518 31H26.0586L16.8765 11.3808L25.9736 0H17.3441L7.43924 12.6548V0H0V31H7.43924V21.5726L11.4777 16.3918L18.1518 31Z",
    fill: "url(#paint0_linear_203_20768)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5199 31H35.9166V21.7H41.7405L46.119 31H54.2809L48.4995 19.789C51.6028 17.963 53.5157 14.6082 53.5157 10.6589C53.5157 4.79863 49.3497 0 41.868 0H28.5199V31ZM41.3154 6.75205C44.4186 6.75205 45.9489 8.28082 45.9489 10.8288C45.9489 13.1219 44.4611 14.9904 41.3154 14.9904H35.9166V6.75205H41.3154Z",
    fill: "url(#paint1_linear_203_20768)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3749 31H62.8566L64.472 26.3712H76.3323L77.9477 31H85.4719L73.9942 0H66.8526L55.3749 31ZM70.4234 9.51233L74.0792 19.9164H66.7675L70.4234 9.51233Z",
    fill: "url(#paint2_linear_203_20768)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.244 31H114.151L104.968 11.3808L114.066 0H105.436L95.5312 12.6548V0H88.0919V31H95.5312V21.5726L99.5696 16.3918L106.244 31Z",
    fill: "url(#paint3_linear_203_20768)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.612 31H138.037V24.1205H124.009V18.8548H138.037V11.9753H124.009V6.87945H138.037V0H116.612V31Z",
    fill: "url(#paint4_linear_203_20768)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.516 31H149.615V11.5082L161.816 31H169V0H161.943V18.6L150.253 0H142.516V31Z",
    fill: "url(#paint5_linear_203_20768)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_20768",
    x1: 33.8288,
    y1: 27.2292,
    x2: 41.7578,
    y2: -15.9835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84F11E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_203_20768",
    x1: 33.8288,
    y1: 27.2292,
    x2: 41.7578,
    y2: -15.9835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84F11E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_203_20768",
    x1: 33.8288,
    y1: 27.2292,
    x2: 41.7578,
    y2: -15.9835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84F11E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_203_20768",
    x1: 33.8288,
    y1: 27.2292,
    x2: 41.7578,
    y2: -15.9835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84F11E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_203_20768",
    x1: 33.8288,
    y1: 27.2292,
    x2: 41.7578,
    y2: -15.9835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84F11E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_203_20768",
    x1: 33.8288,
    y1: 27.2292,
    x2: 41.7578,
    y2: -15.9835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84F11E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6c452279ae81d8e4ef0af5b22fe3130e.svg";
export { ForwardRef as ReactComponent };